<div class="pt-5">
  <app-contact-us-form></app-contact-us-form>
</div>
<div class="footer-wave" aria-hidden="true"></div>
<div class="footer w-100 pt-5">
  <div class="row px-5">
    <div class="col-12 col-md-6 col-xl-3">
      <div class="d-flex flex-column align-items-center align-items-xl-start w-100">
        <img src="/assets/images/logos/footer-logo.png" alt="My Pool Hut Simple Logo">
        <a class="pt-3" href="{{'tel:'+phoneNumber}}" (click)="callUs()">{{phoneNumber}}</a>
        <a class="pt-3" href="{{'mailto:'+ourEmail}}" target="_blank">{{ourEmail}}</a>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3">
      <div class="d-flex flex-column align-items-center align-items-xl-start mt-5 mt-xl-0">
        <h3><a routerLink="/">About Us</a></h3>
        <a class="pt-3" routerLink="/about-us">About My Pool Hut</a>
        <a class="pt-3" routerLink="/policy/shipping-policy">Shipping Policy</a>
        <a class="pt-3" routerLink="/policy/refund-policy">Return Policy</a>
        <a class="pt-3" routerLink="/policy/privacy-policy">Privacy Policy</a>
        <a class="pt-3" routerLink="/policy/terms-of-service">Terms of Service</a>
        <a class="pt-3" routerLink="/frequently-asked-questions">FAQ</a>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3">
      <div class="d-flex flex-column align-items-center align-items-xl-start mt-5 mt-xl-0">
        <h3><a routerLink="/">Popular Brands</a></h3>
        <a class="pt-3" routerLink="/pool-care" [queryParams]="{brands: 'baquacil'}">Baquacil</a>
        <a class="pt-3" routerLink="/pool-care" [queryParams]="{brands: 'bioguard'}">BioGuard</a>
        <a class="pt-3" routerLink="/hot-tub-care" [queryParams]="{brands: 'freshwater'}">FreshWater</a>
        <a class="pt-3" routerLink="/hot-tub-care" [queryParams]="{brands: 'frog'}">Frog</a>
        <a class="pt-3" routerLink="/hot-tub-care" [queryParams]="{brands: 'leisure time'}">Leisure Time</a>
        <a class="pt-3" routerLink="/pool-care" [queryParams]="{brands: 'poolife'}">Pool Life</a>
        <a class="pt-3" routerLink="/hot-tub-care" [queryParams]="{brands: 'sirona'}">Sirona</a>
        <a class="pt-3" routerLink="/hot-tub-care" [queryParams]="{brands: 'spaguard'}">SpaGuard</a>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3">
      <div class="d-flex flex-column align-items-center align-items-xl-start mt-5 mt-xl-0">
        <h3><a routerLink="/">Newsletter Sign Up</a></h3>
        <form [formGroup]="newsletterForm">
          <div class="d-flex flex-column justify-content-center align-items-start">
            <mat-form-field class="medium-input me-0 mt-4 me-xl-3">
              <input type="text"
                placeholder="Email Address"
                aria-label="Email"
                matInput
                formControlName="email"
                required>
                @if (email.invalid) {
                  <mat-error>{{getErrorMessage()}}</mat-error>
                }
              </mat-form-field>
              <button class="accent small-btn" (click)="submit()">
                Sign Up
              </button>
            </div>
            <div class="footer-icon d-flex align-items-center justify-content-center mt-4">
              <a href="https://www.youtube.com/@mypoolhut" class="px-1 ps-xl-0 yt">
                <fa-icon class="custom-badge" [icon]="['fab', 'youtube']" size="2x"></fa-icon>
              </a>
              <a href="https://www.facebook.com/MyPoolHut" class="px-1 ps-xl-3 fb">
                <fa-icon class="custom-badge" [icon]="['fab', 'facebook-square']" size="2x"></fa-icon>
              </a>
              <a href="https://www.instagram.com/mypoolhut/" class="px-1 ps-xl-3 ig">
                <fa-icon class="custom-badge" [icon]="['fab', 'instagram']" size="2x"></fa-icon>
              </a>
              <a href="https://twitter.com/MyPoolHut" class="px-1 ps-xl-3 tw">
                <fa-icon class="custom-badge" [icon]="['fab', 'twitter']" size="2x"></fa-icon>
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center mt-5 mb-3">
        <span>&copy;Copyright {{year}} My Pool Hut</span>
      </div>
    </div>
  </div>
